<template>
  <main>
    <div
      v-if="!email"
      class="registration-forms">
      <h1 class="registration__title">Регистрация клиники</h1>
      <form-registration
        class="registration__form"
        ref="form"
        v-bind:violation-causes="violationCauses"
        v-on:registration-submit="submit" />
      <div class="registration__description">
        Уже есть аккаунт?
        <router-link
          :to="{ name: 'Auth' }"
          class="">Войти
        </router-link>
      </div>
    </div>
    <div v-else class="registration-completed">
      <h1 class="registration-completed__title">Пожалуйста, проверьте ваш почтовый ящик</h1>
      <p>
        Для завершения процедуры регистрации нажмите на ссылку
        в письме, отправленном на ваш адрес:
      </p>
      <p class="registration-completed__email">{{email}}</p>
      <p>
        Не получили письмо? Проверьте папку "Спам"<br>
        <button class="registration__resend" type="button" v-on:click="onResendActivationEmail">
          Отправить повторно
          <span v-if="isTimeout"> через {{seconds}} секунд</span>
        </button>
      </p>
      <p class="registration__help">
        <span>
          Если у вас возникнут вопросы, связанные с регистрацией или доступом в систему,
          напишите на почту
        </span>
        <a
          class="registration__help__email"
          v-bind:href="$options.supportEmailHref">
          {{ $options.supportEmailTitle }}
        </a>
        <span>или позвоните</span>
        <a
          class="registration__help__tel"
          v-bind:href="$options.supportPhoneHref">
          {{ $options.supportPhoneTitle }}
        </a>
      </p>
    </div>
  </main>
</template>
<script>
import aboutMixin from '@/mixins/aboutMixin';
import focusArrowMixin from '@/mixins/focusArrowMixin';
import { GOAL_COMPLETED_REGISTRATION } from '@/plugins/metric';
import FormRegistration from '@/components/FormRegistration.vue';
import notifierMixin from '@/mixins/notifierMixin';

export default {
  components: {
    FormRegistration,
  },
  data() {
    return {
      violationCauses: {},
      email: '',
      clinicId: '',
      isTimeout: false,
      seconds: 0,
    };
  },
  methods: {
    async onResendActivationEmail() {
      if (this.isTimeout === false) {
        const either = await this.$authGateway.resendActivationEmail(this.email);
        either
          .fold(
            (error) => {
              this.notifyError(error.title);
              const causes = error.causes || [];
              if (causes.length && causes[0]?.source === 'already_activated') {
                this.$router.push({ name: 'Auth' });
              }
            },
            (response) => {
              this.notifySuccess(response.title);
              this.isTimeout = true;
            },
          );
      }
    },
    submit(request) {
      this.$registerClinicGateway.send(this.$route.query)(request).then((result) => {
        result.forEach((response) => {
          this.$goal(GOAL_COMPLETED_REGISTRATION);
          this.violationCauses = {};
          this.notifySuccess(response.message);
          this.email = request.toQuery().user_email;
          this.clinicId = response.clinicId;
          this.isTimeout = true;
        });
        result.forEachFail((error) => {
          const causes = {};
          error.causes.forEach((cause) => {
            causes[cause.source] = cause.details;
          });
          this.violationCauses = causes;
        });
      });
    },
  },
  mixins: [
    aboutMixin,
    focusArrowMixin,
    notifierMixin,
  ],
  watch: {
    isTimeout(value) {
      if (value) {
        this.seconds = this.$options.timer / 1000;
        const intervalId = setInterval(() => {
          this.seconds -= 1;
        }, 1000);
        setTimeout(() => {
          this.isTimeout = false;
          clearInterval(intervalId);
        }, this.$options.timer);
      }
    },
  },
  timer: 1000 * 60,
  name: 'ClinicRegistration',
};
</script>
<style lang="scss" scoped>
.registration {
  &__resend {
    text-align: left;
    color: var(--action-color);
  }
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 50px;
    line-height: 60px;
    margin: 0 auto 40px 0;
  }
  &-forms {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 589px;
    width: 100%;
    margin: 0 auto;
  }
  &__description {
    color: #000000;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    margin: 38px auto 0 0;
    a {
      text-decoration: none;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__link {
    font-size: 18px;
    line-height: 24px;
    margin: 10px auto 0 0;
    text-align: center;
    a {
      text-decoration: none;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &-completed {
    max-width: 680px;
    padding: 20px;
    align-self: center;
    justify-self: center;
    text-align: left;
    margin: 0 auto;
    &__email {
      margin: 20px 0 !important;
      color: var(--action-color);
      font-size: 30px;
      overflow-wrap: anywhere;
    }
    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 50px;
      line-height: 60px;
      margin: 0 auto 40px 0;
    }
  }
  &-completed > p {
    margin-top: 1rem;

  }
  &__help {
    display: block;
    &__email,
    &__tel {
      padding: 0 2px;
    }
    &__tel {
      white-space: nowrap;
    }
  }
  &__apps {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
    margin: 38px auto 0 0;
  }
}
@media screen and (max-width: 1200px) {
  .registration-forms {
    margin: 30px auto 0 auto;
    padding: 0 20px 40px;
  }
}
@media screen and (max-width: 480px) {
  .registration {
    &-forms {
      margin: 30px auto 100px auto;
    }
    &__title {
      font-size: 28px;
      line-height: 30px;
      margin: 0 auto 20px 0;
    }
  }
}
</style>
